// src/redux/credibilityChip/credibilityChipActions.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import CredibilityChipAPI from "./credibilityChipAPI";

export const fetchPostChip = createAsyncThunk(
  "credibilityChip/fetchPostChip",
  async (postId, { rejectWithValue }) => {
    try {
      return await CredibilityChipAPI.fetchPostChip(postId);
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchUserChips = createAsyncThunk(
  "credibilityChip/fetchUserChips",
  async (userId, { rejectWithValue }) => {
    try {
      return await CredibilityChipAPI.fetchUserChips(userId);
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
